module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img75.41d66ec0.jpg";